import plane from '../images/aeroplane4.png';

export default function Quote(){
    return(
        <div className="getintouch-bg">
            <div className="row getintouch-bg-inner">
                <div className="col-sm-5">
                    <p>Get In Touch</p>
                    <br />
                    <h1>Looking for the best logistics<br /> transport services </h1>
                </div>
                <div className="col-sm-4" style={{justifyContent: 'center'}}>
                    <img id="airplane" src={plane} alt="3 keys logistics." width="100%" />
                </div>
                <div className="col-sm-3 getintouch-bg-inner-column2">
                    <h1 style={{textAlign:'center', fontWeight:'bolder',fontSize:'50px'}}>3 Keys Logistics Delivers Fast</h1>
                </div>
            </div>
        </div>
    );
}